import { createEntityAdapter, EntityAdapter, EntityState } from "@ngrx/entity";
import { Action, createReducer, on } from "@ngrx/store";
import { IAMAccountActions } from "../actions";

export const IAM_ACCOUNT_FEATURE_KEY = "iam-account";

export interface IAMAccountState extends EntityState<void> {
  passwordUpdateIsLoading: boolean;
  signInIsLoading: boolean;
}

export const iamAccountAdapter: EntityAdapter<void> =
  createEntityAdapter<void>();

const initialState: IAMAccountState = iamAccountAdapter.getInitialState({
  passwordUpdateIsLoading: false,
  signInIsLoading: false
});

const reducer = createReducer(
  initialState,
  on(IAMAccountActions.iamAccountSignIn, (state) => ({
    ...state,
    signInIsLoading: true
  })),
  on(
    IAMAccountActions.iamAccountSignInSuccess,
    IAMAccountActions.iamAccountSignInFailure,
    (state) => ({ ...state, signInIsLoading: false })
  ),
  on(IAMAccountActions.iamAccountPasswordUpdate, (state) => ({
    ...state,
    passwordUpdateIsLoading: true
  })),
  on(
    IAMAccountActions.iamAccountPasswordUpdateSuccess,
    IAMAccountActions.iamAccountPasswordUpdateFailure,
    (state) => ({
      ...state,
      passwordUpdateIsLoading: false
    })
  )
);

export function iamAccountReducer(
  state: IAMAccountState | undefined,
  action: Action
) {
  return reducer(state, action);
}
